import type { ReactionResourceOption } from "./suggestion-types";

/** Whitespace-only query behaves like an empty `{` opener (show full list). */
function isEmptyQuery(query: string): boolean {
	return query.length === 0 || /^\s+$/.test(query);
}

/**
 * Filters resource options by raw query text (case-insensitive substring match).
 */
export function filterResourcesByQuery(
	resources: ReactionResourceOption[],
	query: string,
): ReactionResourceOption[] {
	if (isEmptyQuery(query)) {
		return resources;
	}

	const normalizedQuery = query.toLowerCase();
	return resources.filter((resource) => {
		if (resource.label.toLowerCase().includes(normalizedQuery)) {
			return true;
		}
		if (resource.value.toLowerCase().includes(normalizedQuery)) {
			return true;
		}
		if (resource.triggerName?.toLowerCase().includes(normalizedQuery)) {
			return true;
		}
		return false;
	});
}
